<template>

    <div :class="'task-tracker with-actions info-box text-white bg-' + (running ? 'primary' : 'secondary')">
        <span :title="titleText" class="info-box-icon" @click="toggleRunning"><i class="fa fa-clock-o"></i></span>
        <div class="info-box-content">
            <span class="buttons"><button :class="'btn btn-sm btn-' + (running ? 'primary' : 'secondary')"
                                          @click="remove">X</button></span>
            <span class="info-box-text"><a :href="taskHref">{{task.name}}</a></span>
            <span class="info-box-number">{{humanizedTime}}</span>

            <div class="progress">
                <div class="progress-bar" :style="'width:' + per + '%'"></div>
            </div>
            <span class="progress-description">
                    EH: {{task.estimated_hours}} hours
            </span>
        </div>
        <!-- /.info-box-content -->
    </div>

</template>

<script>

    let moment = require('moment');
    import _ from 'lodash';

    export default {
        name: 'task-tracker',
        props: {
            task: Object,
            id: String,
        },
        data() {
            return {
                taskHref: laroute.route('tasks.show', {task: this.task.id}),
                time: 0,
                tempId: this.id,
                running: false,
                interval: null,
                runningDiffTab: false,
                timeIntervals: [],
                timeInterval: {
                    from: null,
                    to: null
                }
            }
        },
        mounted() {
            this.loadState();

            this.listenForChanges();
        },
        computed: {
            titleText() {
                if (this.running) {
                    return 'Click to stop timer.';
                } else {
                    return 'Click to start timer.';
                }
            },
            per() {
                let taskEhSeconds = (this.task.estimated_hours * 60 * 60);

                return Math.min(100, Math.round(this.time / taskEhSeconds * 100));
            },
            identity() {
                return 'tasks.' + this.task.id + '.' + this.tempId;
            },
            humanizedTime() {
                if (this.time === 0) {
                    return 'Click on icon to start';
                }
                return moment.duration(this.time, "seconds").humanize();
            },
        },
        watch: {
            running(isRunning) {
                let vm = this;
                if (isRunning) {
                    vm.interval = setInterval(function () {
                        vm.time = _.sumBy(vm.timeIntervals, function (timeInterval) {
                            let to = null;
                            if (timeInterval.to) {
                                to = moment(timeInterval.to);
                            } else {
                                to = moment();
                            }
                            return to.diff(moment(timeInterval.from), 'seconds');
                        });
                    }, 1000);

                } else {
                    clearInterval(vm.interval);
                    vm.interval = null;
                    Vue.ls.set(vm.identity + '.running', false);
                }
            }
        },
        methods: {
            remove() {
                this.$emit('remove', this.id);
            },
            toggleRunning() {
                this.running = !this.running;
                let vm = this;
                if (this.running) {

                    vm.timeIntervals.push({
                        from: moment(),
                        to: null
                    });
                    Vue.ls.set(this.identity + '.time-intervals', vm.timeIntervals);

                } else {

                    let lastIndex = (_.size(vm.timeIntervals) -1);
                    if (lastIndex !== -1) {
                        vm.timeIntervals[lastIndex].to = moment();
                        Vue.nextTick(() => {
                            Vue.ls.set(this.identity + '.time-intervals', vm.timeIntervals);
                        });
                    }

                }
                Vue.ls.set(this.identity + '.running', this.running);
            },
            listenForChanges() {
                let vm = this;
                Vue.ls.on(vm.identity + '.time-intervals', function (timeIntervals, oldTime, uri) {
                    vm.timeIntervals = timeIntervals;
                });
                Vue.ls.on(vm.identity + '.running', function (running, oldRunning, uri) {
                    vm.running = running;
                });
            },
            loadState() {
                let vm = this;
                vm.running = Vue.ls.get(vm.identity + '.running', false);
                vm.timeIntervals = Vue.ls.get(vm.identity + '.time-intervals', []);

                vm.time = _.sumBy(vm.timeIntervals, function (timeInterval) {
                    let to = null;
                    if (timeInterval.to) {
                        to = moment(timeInterval.to);
                    } else {
                        to = moment();
                    }
                    return to.diff(moment(timeInterval.from), 'seconds');
                });

            }
        }
    }
</script>

<style scoped lang="scss">
    .task-tracker {
        .info-box-icon {
            cursor: pointer;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/tasks/TaskTracker.vue